import { IState } from '../types';
import { getAudioById } from '../models/selectors';
import { TAudioType } from '../models/types';

export const AUDIO_MOVIE_KEY_PREFIX = 'audio-';

export const getCurrentMovieKey = (state: IState) => {
  return getCurrentAudioId(state) ? getCurrentAudioKey(state) : getCurrentVideoKey(state);
}

export const getCurrentVideoKey = (state: IState) => state.currentVideo.currentVideoId;
export const getCurrentAudioId = (state: IState) => state.currentVideo.currentAudioId;

export const getCurrentAudioKey = (state: IState) => {
  return AUDIO_MOVIE_KEY_PREFIX + getCurrentAudioId(state);
}

export const isAudioMovieKey = (key: string): boolean => {
  return key.indexOf(AUDIO_MOVIE_KEY_PREFIX) === 0;
}

export const getAudioIdByKey = (key: string): number => {
  return parseInt(key.substring(AUDIO_MOVIE_KEY_PREFIX.length));
}

export const getAudioKeyById = (id: number): string => {
  return AUDIO_MOVIE_KEY_PREFIX + id;
}

export const getAvailableCaptions = (state: IState) => state.currentVideo.availableCaptions;

export const getSelectedNativeCaption = (state: IState) => state.currentVideo.selectedNativeCaption;
export const getSelectedTargetCaption = (state: IState) => state.currentVideo.selectedTargetCaption;

export const getCurrentVideoClickedCaptionIndex = (state: IState) => state.currentVideo.clickedCaptionIndex;

export const getCurrentCaptionsFixStatus = (state: IState) => state.currentVideo.captionsFixStatus;

export const getPlayerVideoId = (state: IState) => state.currentVideo.playerVideoId;

export const isCurrentPlayerExist = (state: IState) => {
  const audioId = getCurrentAudioId(state);
  const audio = audioId ? getAudioById(state, audioId) : null;
  return !audio || audio.type === TAudioType.AUDIO;
}
